import React, { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Button, Col, Container, Row } from "react-bootstrap";
import Nav from "./Navbar";
import Footer from "./Footer";
import tool5 from "../Images/tool5.png";
import tool4 from "../Images/tool4.png";
import Domainpage from "./Dapa";
const Domainoverview = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    const script = document.createElement("script");
    script.type = "module";
    script.src = "/off_seo.js";
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div className="p-0">
      <div>
        <Nav />
      </div>

      <Row className="d-flex justify-content-center">
        <Col md={10}>
          <div className="">
            <h1 className="text-center m-md-4 m-2">
              Domain Overview Tool: Examine Your Website's Authority in Just One
              Click
            </h1>
            <div
          className=" mt-md-5 p-4 "
          style={{
            background:
              "linear-gradient(to right, #AFDDFF 0%, #C5E7FF 30%, #DAF0FF 60%, #EDF8FF 85%, #FFFFFF 100%)",
          }}
        >
          <h2
            style={{ color: "#0A3981" }}
            className="d-flex justify-content-center pt-5"
          >
            <b> Check Your Domain Authority and Age Instantly</b>
          </h2>
          <Domainpage />
        </div>
            <p className="mt-md-5 mt-2">
              Thinking about improving your website performance? The{" "}
              <b>Domain Overview Tool</b> by Seobix helps you instantly analyze
              three core SEO metrics{" "}
              <b>Domain Authority (DA), Page Authority (PA), and Spam Score</b>{" "}
              —so you can make smarter strategies. It’s a must-have tool for
              anyone looking to increase website traffic with structured data
              and want to improve their online visibility.
            </p>
            <h2 className="text-center m-3">What You Get in SeoBix Domain Overview Tool ?</h2>
            <p>
              When you run your website through the Seobix Domain Overview Tool,
              you’re not just seeing numbers—you’re getting real, accurate
              insights that matter. Here’s what each feature stand for :
            </p>
            <div className="d-flex justify-content-center">
              <img
                className="mb-3"
                src={tool4}
                alt="seobix"
                style={{ width: "80vw" }}
              />
            </div>
            <h3>Domain Authority Checker</h3>
            <p>
              This tool helps you to understand how powerful your domain is in
              the eyes of search engines. It’s scored on a scale from 1 to
              100—the higher your score, the stronger your site is likely to
              rank. Use this insight to measure growth, examine your competitors
              , and make better SEO moves.
            </p>
            <h3>Page Authority Checker</h3>
            <p>
              Not all pages are created equal. This tool goes deeper to examine
              the authority of specific URLs on your site. No matter it’s your
              homepage or a blog post, knowing about <b>Page Authority</b> helps
              you in identifying which content is holding value—and which needs
              work.
            </p>
            <h3>Spam Score Analyzer</h3>
            <p>
              Do you know ? Even one toxic backlink can put your site at risk.
              Our <b>Spam Score tool</b> checks the trustworthiness of your
              domain and alerts you to suspicious links or patterns. This is
              your early warning system to prevent penalties and keep your SEO
              profile clean.
            </p>
            <h2>Best Structured Data Tools for Small Businesses</h2>
            <p>
              Our Domain Overview tool gives you actionable and trustworthy
              insights without requiring any technical knowledge. That’s why
              Seobix offers some of the{" "}
              <b>best structured data tools for small businesses</b> designed to
              give you a complete understanding of the domain and its online
              visibility, making it easy to use structured information to
              improve how search engines see your site.
            </p>
            <div className=" mb-3 d-flex justify-content-center">
              <img
                style={{ width: "50vw" }}
                className="mb-3"
                src={tool5}
                alt="seobix"
              />
            </div>
            <h2>Level up Website Traffic with Structured Data</h2>{" "}
            <p className="mb-5">
              When you understand your domain and page authority and you’re
              aware of spam threats you can create better, cleaner, and more
              systematic content. This means{" "}
              <b>you rank better, reach more users</b>, and ultimately{" "}
              <b>increase website traffic with structured data</b> as your
              foundation.
            </p>
          </div>
        </Col>
      </Row>

      <div
        className="m-0 p-0"
        style={{
          overflow: "hidden",
          background: "#31393C",
          borderTopRightRadius: "2rem",
          borderTopLeftRadius: "2rem",
        }}
      >
        <Footer />
      </div>
    </div>
  );
};

export default Domainoverview;
